import { Delete, Edit, Visibility } from '@mui/icons-material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { Card, Grid, IconButton } from '@mui/material';
import { DataGrid, GridColDef, GridSortModel, gridClasses } from '@mui/x-data-grid';
import { isEmpty } from 'lodash-es';
import { useState, useEffect, useCallback } from 'react';
import { FieldValues, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import {
  createAllEvaluationTemplate,
  updateAllEvaluationTemplate,
  deleteAllEvaluationTemplate,
  EvaluationTamplateDTO,
  getAllEvaluationTemplateList,
} from 'wisestep-api';
import {
  WsButton,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsColors,
  SearchBar,
  getDateUsingFormat,
} from 'wisestep-base';

import ConfirmDeleteDialog from '../../components/confirmDeleteDialog/ConfirmDeleteDialog';
import { SettingsPageLayout } from '../../components/SettingsPageLayout';
import Survey from '../../components/SurveyBuilder/Survey';
import { success, warning } from '../../utils/NotificationMessages';
import { useNotificationStore } from '../../utils/NotificationStore';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../teams/helper/defaultValues';

export const evaluationTamplateDTOHelper: EvaluationTamplateDTO = {
  id: '',
  workspaceId: '',
  description: '',
  teamId: '',
  createdBy: '',
  createdOn: '',
  updated_on: '',
  template: '',
  associateStageStatusData: '',
  updatedBy: '',
  templateName: '',
};

const EvaluationTemplate = () => {
  const methods = useForm();
  const [evaluationListData, setEvaluationListData] = useState<EvaluationTamplateDTO[]>([]);
  const [showSurvey, setShowSurvey] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: 'templateName', sort: 'asc' },
  ]);
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);
  const [totalRecord, setTotalRecord] = useState<number>(0);
  const { handleSubmit } = methods;
  const [modeType, setModeType] = useState<number>(0);
  const [templateId, setTemplateId] = useState<string>('');
  const [templateJsonObject, setTemplateJsonObject] = useState<any>('');
  const [getAssociateStatusObject, setAssociateStatusObject] = useState<any>('');
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState<EvaluationTamplateDTO | null>(null);

  const getEvaluationTampList = useCallback(async () => {
    try {
      const query: string = !isEmpty(searchQuery)
        ? encodeURIComponent(
            searchQuery
              .trim()
              .split(' ')
              .map((s) => s + ':*')
              .join(' & ')
          )
        : searchQuery;

      const sortBy = !isEmpty(sortModel) ? sortModel[0].field : undefined;
      const sortOrder = !isEmpty(sortModel) ? sortModel[0].sort : undefined;
      const response = await getAllEvaluationTemplateList(
        pageNo,
        pageSize,
        query,
        sortBy,
        sortOrder
      );

      setTotalRecord(response.data.totalRecord);
      setEvaluationListData(response.data.data);
    } catch (error) {
      console.log('error', error);
    }
  }, [searchQuery, sortModel, pageNo, pageSize]);

  useEffect(() => {
    setShowSurvey(false);
    getEvaluationTampList();
  }, [getEvaluationTampList]);

  const createAssociateStatus = () => {
    setModeType(0);
    setTemplateId('');
    setTemplateJsonObject(null);
    setAssociateStatusObject(null);
    setShowSurvey(true);
  };

  const handleDeleteItem = async (data: any) => {
    setOpenDeleteDialog(true);
    setSelectedItem(evaluationListData[data]);
  };
  const deleteSurvey = async () => {
    try {
      await deleteAllEvaluationTemplate(selectedItem?.id);
      getEvaluationTampList();
    } catch (error) {
      console.error('error', error);
    } finally {
      setOpenDeleteDialog(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  const callBackUpdateSurvay = async (data: any) => {
    const avPayload = { ...evaluationTamplateDTOHelper };
    avPayload.id = data.id;
    avPayload.description = data.description;
    avPayload.template = data.template;
    avPayload.templateName = data.templateName;
    avPayload.associateStageStatusData = data.associateStageStatusData;

    if (data.templateName === undefined || data.templateName === '') {
      setNotification(warning(`Oops , Template Name is missing !!`));
    } else {
      try {
        await updateAllEvaluationTemplate(data.id, avPayload);
        setNotification(success(`${data.templateName} has been updatd successfully !!`));
        getEvaluationTampList();
        showBackTemplateList();
      } catch (error: any) {
        setNotification(warning(`Oops , ${data.templateName} already exists!!`));
        console.log('error', error);
      }
    }
  };

  const callBackAddSurvay = async (data: any) => {
    if (data.templateName === undefined || data.templateName === '') {
      setNotification(warning(`Oops , Template Name is missing !!`));
    } else {
      try {
        data?.template?.pages?.map((page, pageIndex) => {
          page?.elements?.map((questionObj, elemnetIndex) => {
            if (!questionObj?.title) {
              data.template.pages[pageIndex].elements[elemnetIndex].title = questionObj?.name;
            }
          });
        });
        await createAllEvaluationTemplate(data);
        setNotification(success(`${data.templateName} has been added successfully !!`));
        getEvaluationTampList();
        showBackTemplateList();
      } catch (error: any) {
        setNotification(warning(`Oops , ${data.templateName} already exists!!`));
        console.log('error', error);
      }
    }
  };

  const showBackTemplateList = () => {
    setModeType(0);
    setTemplateId('');
    setShowSurvey(false);
    getEvaluationTampList();
  };

  const handleEditItem = async (id: string) => {
    setModeType(1);
    setTemplateId(evaluationListData[id].id);
    setTemplateJsonObject(JSON.parse(JSON.stringify(evaluationListData[id].template)));
    setAssociateStatusObject(
      JSON.parse(JSON.stringify(evaluationListData[id].associateStageStatusData))
    );

    setShowSurvey(true);
  };
  const viewTamplate = (id: string) => {
    setModeType(2);
    setTemplateId(evaluationListData[id].id);
    setTemplateJsonObject(JSON.parse(JSON.stringify(evaluationListData[id].template)));
    setAssociateStatusObject(
      JSON.parse(JSON.stringify(evaluationListData[id].associateStageStatusData))
    );

    setShowSurvey(true);
  };

  const onSearch = (data) => setSearchQuery(data?.query ?? '');

  const tableData: Record<string, unknown>[] = [];

  evaluationListData.forEach((evaluationData, index) => {
    tableData.push({
      id: evaluationData.id,
      description: evaluationData.description,
      templateName: evaluationData.templateName,
      createdBy: evaluationData.recruiter_name,
      created_on: evaluationData.createdOn,
      index: index,
    });
  });

  const columns: GridColDef[] = [
    {
      field: 'templateName',
      headerName: 'Title',
      flex: 0.5,
      renderCell: (params) => (
        <WsTypography
          variant={WsTypoVariants.SUB_TITLE}
          bold
          color={WsTypoColors.PRIMARY}
          cursor="pointer"
        >
          {params.row['templateName']}
        </WsTypography>
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 0.5,
    },
    {
      field: 'createdBy',
      headerName: 'Created By',
      flex: 0.5,
    },
    {
      field: 'created_on',
      headerName: 'Created On',
      flex: 0.5,
      renderCell: (params) => <>{getDateUsingFormat(params.row['created_on'], 'DD-MMM-YY')}</>,
    },
    {
      field: 'Action',
      headerName: 'Action',
      flex: 0.5,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => viewTamplate(params.row['index'] as string)}>
            <Visibility color="primary" />
          </IconButton>
          <IconButton onClick={() => handleEditItem(params.row['index'] as string)}>
            <Edit color="primary" />
          </IconButton>
          <IconButton onClick={() => handleDeleteItem(params.row['index'] as string)}>
            <Delete color="primary" />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <SettingsPageLayout
      title={'Evaluation Template List'}
      indexOptions={[{ label: 'Evaluation Template', url: '/evaluation-template' }]}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.CRM,
        Pages['EVALUTION_TEMPLATES']
      )}
    >
      {showSurvey ? (
        <Survey
          modeType={modeType}
          jsonObject={templateJsonObject}
          associateJsonObject={getAssociateStatusObject}
          tamplateId={templateId}
          backToTemplate={showBackTemplateList}
          addGetDataBack={callBackAddSurvay}
          updateGetDataBack={callBackUpdateSurvay}
        />
      ) : (
        <Grid sx={{ backgroundColor: WsColors.TheBlues50 }} container py={1}>
          <ConfirmDeleteDialog
            open={openDeleteDialog}
            onClose={handleCloseDialog}
            onConfirm={deleteSurvey}
            deletingItem={`${selectedItem?.templateName ?? ''} template`}
          />
          <Grid item xs={12} justifyContent="flex-end" pt={2}>
            <FormProvider {...methods}>
              <Grid
                container
                sx={{ display: 'flex' }}
                component="form"
                onSubmit={handleSubmit(onSearch as SubmitHandler<FieldValues>)}
              >
                <Grid item xs={8} p={1}>
                  <Card sx={{ p: 0.5 }}>
                    <SearchBar name="query" placeholder="Search for Name" />
                  </Card>
                </Grid>
                <Grid item xs={2} p={1}>
                  <WsButton
                    fullWidth
                    variant="outlined"
                    size="large"
                    type="reset"
                    onClick={() => {
                      methods.reset();
                      onSearch(methods.getValues());
                    }}
                  >
                    Clear
                  </WsButton>
                </Grid>
                <Grid item xs={2} p={1}>
                  <WsButton
                    fullWidth
                    variant="outlined"
                    size="large"
                    type="submit"
                    startIcon={<SearchIcon />}
                  >
                    Search
                  </WsButton>
                </Grid>
              </Grid>
            </FormProvider>
          </Grid>
          <Grid item xs={12} sx={{ ml: 8 }} container justifyContent="flex-end">
            <Grid item xs={3} p={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <WsButton
                fullWidth
                onClick={() => createAssociateStatus()}
                variant="contained"
                size="large"
                startIcon={<AddOutlinedIcon />}
              >
                Add Template
              </WsButton>
            </Grid>
          </Grid>
          <Grid xs={12} sx={{ backgroundColor: 'white' }}>
            <DataGrid
              autoHeight={true}
              columns={columns}
              rows={tableData}
              onPageChange={(page) => setPageNo(page)}
              page={pageNo}
              rowCount={totalRecord}
              pageSize={pageSize}
              rowsPerPageOptions={[25, 50, 75, 100]}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              onSortModelChange={(newSortModel) => {
                setPageNo(0);
                setSortModel(newSortModel);
              }}
              sortingMode="server"
              paginationMode="server"
              getRowHeight={() => 'auto'}
              sx={{
                [`& .${gridClasses.cell}`]: {
                  py: 1,
                },
              }}
            />
          </Grid>
        </Grid>
      )}
    </SettingsPageLayout>
  );
};

export default EvaluationTemplate;
